import i18n, { InitOptions } from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'

// 定义类型安全的配置对象
const initOptions = {
  debug: true,
  fallbackLng: {
    'zh': ['zh'],
    'default': ['en']
  },
  nonExplicitSupportedLngs: true,
  // 指定支持的语言列表（可选）
  // 回退到主语言的方式
  load: 'languageOnly',
  supportedLngs: ['en', 'zh'],
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage'],
    lookupLocalStorage: 'language', // 默认存储键名（可自定义）
    htmlTag: document.documentElement,
    cookieMinutes: 60 * 24 * 7
  }
} as InitOptions

i18n
  .use(Backend)
  // 检测用户当前使用的语言
  // 文档: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // 注入 react-i18next 实例
  .use(initReactI18next)
  // 初始化 i18next
  // 配置参数的文档: https://www.i18next.com/overview/configuration-options
  .init(initOptions)
  .then(() => {
    const newLanguage = i18n.language.startsWith('zh') ? 'zh' : 'en'
    localStorage.setItem('language', newLanguage)
    // console.log('i18n 初始化结束:', i18n.language)
  })

export default i18n
